/**
 * Splits an incoming `systemSetupCommands` list into the contiguous
 * prefix that matches the host-managed base blueprint chain
 * (`inherited`) and any user-added extras (`extras`).
 *
 * The base blueprint's setup commands are the concatenation of host
 * core + plugin contributions + per-org overrides — operators must NOT
 * remove or reorder them. The blueprint editor locks the matching
 * prefix and only lets the user edit the tail.
 *
 * Returns `{ inherited: [], extras: source }` when `baseChain` is
 * empty or doesn't match, which keeps the legacy "all editable"
 * behaviour for derived blueprints that don't carry the full chain
 * inline (Runloop handles inheritance natively via
 * `base_blueprint_name`).
 */
export function splitInheritedFromBase(
  source: string[],
  baseChain: string[] | undefined,
): { inherited: string[]; extras: string[] } {
  if (!baseChain || baseChain.length === 0 || source.length < baseChain.length) {
    return { inherited: [], extras: source };
  }
  for (let i = 0; i < baseChain.length; i += 1) {
    if (source[i] !== baseChain[i]) {
      return { inherited: [], extras: source };
    }
  }
  return { inherited: baseChain.slice(), extras: source.slice(baseChain.length) };
}
